<template>
		<MainLayout>
			<div class="container">
				<b-overlay :show="load.search" no-wrap></b-overlay>
				<div class="box p-3 mb-1">
					<b-form>
						<b-form-group
							label="Journey type:"
							label-cols-sm="1"
							label-align-sm="left"
							class="mb-1"
						>
							<b-form-radio-group
							class="pt-2"
							v-model="filters.journey"
							:options="[{value:'oneway',text:'One way'},{value:'roundtrip',text:'Roundtrip'}]"
							></b-form-radio-group>
						</b-form-group>
						<b-row>
								<b-form-group
								class="col-12 col-sm-2"
								label="Origen:"
							>
								<b-form-input
								v-model="filters.iataFrom"
								placeholder="Eje : CUN"
								></b-form-input>
							</b-form-group>

							<b-form-group
								class="col-12 col-sm-2"
								label="Destino:"
							>

								<b-form-input
								v-model="filters.iataTo"
								placeholder="Eje : MEX"
								></b-form-input>
							</b-form-group>
							<b-col class=" col-auto" >
								<b-row>
									<b-col class="col-sm-auto col-12">
										<b-form-group  label="Fecha salida">
											<b-form-datepicker locale="es" reset-button v-model="filters.departureDate" />
										</b-form-group>

									</b-col>
									<b-col class="col-auto" v-if="filters.journey==='roundtrip'" >
										<b-form-group  label="Regreso Fecha salida">
											<b-form-datepicker locale="es" reset-button v-model="filters.returnDepartureDate" />
										</b-form-group>

									</b-col>
								</b-row>

							</b-col>

							<b-form-group class="col-12 col-sm-3">
								<b-row>
									<b-form-group :label="'Adultos'" class="col-6 col-sm-4">
										<b-form-select  v-model="filters.adults">
											<b-form-select-option v-for="(item, i) in 20" :value="i" :key="i">{{i}}</b-form-select-option>
										</b-form-select>
									</b-form-group>
									<b-form-group :label="'Menores'" class="col-6 col-sm-4">
										<b-form-select v-model="filters.children">
											<b-form-select-option v-for="(item, i) in 20" :value="i" :key="i">{{i}}</b-form-select-option>
										</b-form-select>
									</b-form-group>
								</b-row>

							</b-form-group>
						</b-row>
						<b-row>
							<b-form-group
								class="col-12 col-sm-3"
								label="Clase:"
							>
								<b-form-select  :options="cabinClassOpts" v-model="filters.cabinClass"></b-form-select>
							</b-form-group>
							<b-form-group class=" col-12 col-sm-2 text-center text-sm-left">
								<b-button ref="toScroll" type="button" variant="primary" class="mt-sm-4 " @click="search">Buscar</b-button>
							</b-form-group>
						</b-row>
					</b-form>
				</div>
				<div class="box" v-if="$hasPermission('flightCalculator.show')">
					<div class="card m-3" v-for="(item, i) in listOfferResponse.data" :key="i">
						<div class="card-body">
							<b-row>
								<b-col class="content-journey">
									<b-row v-for="(itemSlice, keySlice) in item.slices"  :key="keySlice">
										<b-col class="col-6 col-sm-2">
											<span>{{item.owner.name}} </span>
										</b-col>
										<b-col class="col-6 col-sm-2">
											<p>{{getStartAndEndTime(itemSlice.segments)}}</p>
										</b-col>
										<b-col class="col-6 col-sm-4">
											<div class="text-center">
												<p class="p-0 m-0"><md-icon :icon="'schedule'"/> {{getDuration(itemSlice.duration)}}</p>
												<p class="p-0 text-muted"><b>{{itemSlice.origin.iata_code}} -> {{itemSlice.destination.iata_code}} </b></p>
											</div>
										</b-col>
										<b-col class="col-6 col-sm-1">
											<p v-if="itemSlice.segments.length ===1">Directo</p>
											<p v-if="itemSlice.segments.length >1">{{itemSlice.segments.length-1}} stop</p>
										</b-col>
										<b-col class="col-6 col-sm-3">
											<p class="m-0 p-0"  v-for="(_segment, _keySegment) in itemSlice.segments"  :key="_keySegment">
												<small class="text-muted">{{_segment.marketing_carrier.iata_code}}-{{_segment.marketing_carrier_flight_number}}</small>
											</p>
										</b-col>


										<b-collapse :id="'detail-'+i" class=" detail-journey container">
											<b-col cols="12"  v-for="(segment, keySegment) in itemSlice.segments"  :key="keySegment">
												<b-row>
													<b-col>
														{{formatDate(segment.departing_at)}} depart at {{segment.origin.name}} ({{segment.origin.iata_code}})
													</b-col>

												</b-row>

												<b-row>
													<b-col>
														{{formatDate(segment.arriving_at)}} arriving at {{segment.destination.name}} ({{segment.destination.iata_code}})
													</b-col>
												</b-row>
												<b-row>
													<b-col>
														<small class="text-muted pr-3"> <md-icon :icon="'schedule'"/> Duration: {{getDuration(segment.duration)}}</small>
														<small class="text-muted pr-3">{{segment.marketing_carrier.name}}  </small>
														<small class="text-muted">{{segment.marketing_carrier.iata_code}}-{{segment.marketing_carrier_flight_number}}</small>
													</b-col>
												</b-row>

												<hr>
											</b-col>
										</b-collapse>



									</b-row>
								</b-col>
								<b-col class="col-sm-auto col-12 price">
									<b-button variant="success">{{getTotalText(item)}}</b-button>
									<p class="m-1 p-0"><small class="text-muted"><md-icon :icon="'cloud'"/> {{item.total_emissions_kg}} kg CO<sub>2</sub></small></p>
									<a class="text-primary" style="cursor:pointer" v-b-toggle :href="'#detail-'+i" @click.prevent><small>Show / Hide Detail</small></a>
								</b-col>
							</b-row>
						</div>
					</div>

					<div class="row mt-3">
						<b-col>
							<b-button-group class="float-right mr-4">
							<b-button variant="outline-primary" @click="paginationAction('before')" v-if="canGoBefore"> <md-icon :icon="'navigate_before'"/> </b-button>
							<b-button variant="outline-primary" @click="paginationAction('after')" v-if="canGoNext"><md-icon :icon="'navigate_next'"/></b-button>

						</b-button-group>
						</b-col>

					</div>
				</div>
			</div>
		</MainLayout>
</template>
<script>
import api from '../../../api.js'
import MainLayout from '../layout/MainLayout.vue'
import moment from 'moment'
export default {
		components: { MainLayout },
		data(){
			const now     = moment().format("YYYY-MM-DD")
			const returnDate = moment().add(7, 'days').format("YYYY-MM-DD");
			const filtersDefault = {
				iataFrom: "CUN",
				iataTo:"MEX",
				departureDate:now,
				returnDepartureDate:returnDate,
				adults:1,
				children:0,
				cabinClass:"",
				journey:"oneway"

			}
			return {
				load:{
					search:false
				},
				lastResultSearch: {meta:{after:null,before:null},data:[]},
				now:now,
				filters:{...filtersDefault},
				airlinesList:[],
				offerRequest:{id:"orq_0000AFAYRyfbKPVLnkPHCS"},
				listOfferResponse:{meta:{},data:[]},
				paginate:{}
			}
		},
		computed: {
			filtersClean(){
				let slices = [];
				let firstSlice = {origin:this.filters.iataFrom,destination:this.filters.iataTo,departure_date:this.filters.departureDate};
				slices.push(firstSlice);
				if(this.filters.journey==='roundtrip'){
					let returnSlice = {origin:this.filters.iataTo,destination:this.filters.iataFrom,departure_date:this.filters.returnDepartureDate}
					slices.push(returnSlice);
				}
				return {
					slices:slices,
					adults: this.filters.adults,
					children: this.filters.children,
					cabinClass:this.filters.cabinClass

				}
			},
			cabinClassOpts(){
				return [
					{value:"",text:"All"},
					{value:"economy",text:"Economy"},
					{value:"premium_economy",text:"Premium economy"},
					{value:"first",text:"First class"},
					{value:"business",text:"Business"},
				];
			},
			canGoNext(){
				return ((this.listOfferResponse.meta?.after??null) !== null);
			},
			canGoBefore(){
				return ((this.listOfferResponse.meta?.before??null) !== null);
			}
		},
		methods:{
			createOfferRequest(){
				return api(this).post(`quote/flights/offers-requests`,this.filtersClean).then((res) => {
					this.offerRequest = res.data.data;
				})
				.catch((err) => {
					throw err;
				})
				.finally(()=>{
				})
			},
			listOffers(){
				let params = {
					...this.paginate
				};
				return api(this).get(`quote/flights/offers-requests/${this.offerRequest.id}/offers`,{params:params}).then((res) => {
					this.listOfferResponse = res.data;
				})
				.catch((err) => {
					console.log(err);
				})
				.finally(()=>{
				})
			},
			async search(){
				this.resetVarsForSearch();
				this.load.search = true;
				try{
					await this.createOfferRequest();
					await this.listOffers();
				}catch(err){
					console.log(err);
				}finally{
					this.load.search = false;
				}

			},
			async searchWithPagination(){
				this.$refs["toScroll"].focus();
				this.load.search = true;
				try{
					await this.listOffers();
				}catch(err){
					console.log(err);
				}finally{
					this.load.search = false;
				}

			},
			getDuration(duration){
				let text = "";
				const REGEX = /P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?$/;
				let matches = duration.match(REGEX);
				let days    = matches[4];
				let hours   = matches[5];
				let minutes = matches[6];
				if(days)  text+=days+"d "
				if(hours) text+=hours+"h "
				if(minutes) text+=minutes+"m"
				return text
			},
			getTotalText(offer){
				return offer.total_currency+"$"+offer.total_amount;
			},
			showDetail(ref){
				this.$refs[ref].show();
			},
			getStartAndEndTime(segments){
				return ((moment(segments[0].departing_at).format("HH:mm"))+" - "+(moment(segments[segments.length-1].arriving_at).format("HH:mm")))
			},
			paginationAction(action){
				this.paginate = {};
				try{

					if((this.listOfferResponse.meta[action]??null) === null) return ;
					switch(action){
						case "after":
							this.paginate = {after:this.listOfferResponse.meta.after}
							break;
						case "before":
							this.paginate = {before:this.listOfferResponse.meta.before}
							break;
					}
				}catch(err){
					this.paginate = {};
				}
				this.searchWithPagination()
			},
			resetVarsForSearch(){
				this.offerRequest ={};
				this.listOfferResponse={meta:{},data:[]};
				this.paginate = {};
			},
			formatDate(date){
				return moment(date).format("DD/MM/YYYY HH:mm")
			}
		},
		mounted(){

		},
		destroyed(){
		},
		watch:{
		}
}
</script>
